import React, { useContext, useEffect, useState } from 'react';

import { getAgentPhoneNumber } from '../../api';
import { AuthContext } from '../AuthContext';

import { AgentContext } from './AgentContext';

const AgentContextProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const { user } = useContext(AuthContext);
  const paramsString = window.location.search;
  const searchParams = new URLSearchParams(paramsString);

  const [phoneNumber, setPhoneNumber] = useState<string>();

  useEffect(() => {
    if (user && user.email) {
      getAgentPhoneNumber(user.email)
        .then((phoneNumber) => {
          setPhoneNumber(phoneNumber);
        })
        .catch((err) => {
          // TODO: [APPS-3463] Show error popup
          console.error('Unable to load phone numbers', err.message);
        });
    }
  }, [user]);

  const contextValue = {
    fullName: user?.full_name,
    identity: searchParams.get('identity') || user?.email,
    phoneNumber: searchParams.get('phone_number') || phoneNumber,
  };

  return <AgentContext.Provider value={contextValue}>{children}</AgentContext.Provider>;
};

export default AgentContextProvider;
